import { createContext } from 'react';

const ProductOverviewContext = createContext();

export default ProductOverviewContext;
